import React, { useState } from 'react';
import { Collapse } from '@ag1/ui';
import { menuNavigationEvent } from 'analytics/events/studio';

import { SimpleFooterMenuItem } from 'types/studio/footer';
import { MinusIcon, PlusIcon } from '@ag1/ui';
import FooterMenuLink from '../FooterMenuLink/FooterMenuLink';
import styles from './styles.module.scss';

const FooterMenuItemCollapsible = ({ title, links }: SimpleFooterMenuItem) => {
  const [isOpen, setIsOpen] = useState(false);
  const listId = `footer-menu-item-collapsible-${title.toLowerCase()}`;

  const sendNavigationEvent = (label: string) =>
    menuNavigationEvent({
      location: 'footer',
      header: title,
      clickText: label
    });

  return (
    <section className={styles.root}>
      <h3 className={styles.title}>
        <button
          type="button"
          onClick={() => setIsOpen((prev) => !prev)}
          className={styles.button}
          aria-expanded={isOpen}
          aria-controls={listId}>
          <span>{title}</span>
          <span className={styles.icon}>
            {isOpen ? <MinusIcon /> : <PlusIcon hasPadding={false} />}
          </span>
        </button>
      </h3>
      <Collapse isOpened={isOpen} ariaOverride={false}>
        <ul id={listId} className={styles.list}>
          {links
            .filter(({ link }) => !!link)
            .map((linkItem) => (
              <li
                key={linkItem.label}
                className={styles.item}
                onClick={() => sendNavigationEvent(linkItem.label)}
                onKeyDown={() => sendNavigationEvent(linkItem.label)}
                role="presentation">
                <FooterMenuLink {...linkItem} />
              </li>
            ))}
        </ul>
      </Collapse>
    </section>
  );
};

export default FooterMenuItemCollapsible;
